/**
 * Extended Mock Data for Investor Presentation
 * Additional properties and enhanced portfolio data
 */

import { PropertyCardData } from '../components/new-components/PropertyCard';
import { CryptoAsset } from '../components/new-components/CryptoStaking.types';
import {
  FundMetrics,
  FundraisingProgress,
  PerformanceDataPoint,
  AllocationItem,
  FundHighlight,
} from '../components/new-components/HiveFund.types';

export const EXTENDED_MOCK_PROPERTIES: PropertyCardData[] = [
  {
    id: 'prop-001',
    name: 'Sunset Beach Villa',
    address: '2847 Ocean Drive',
    city: 'Miami Beach',
    state: 'FL',
    imageUrl: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1200&auto=format&fit=crop&q=80',
    propertyType: 'vacation-rental',
    price: 1250000,
    totalShares: 2500,
    availableShares: 450,
    targetReturn: 14.5,
    investorCount: 342,
    fundedPercentage: 82,
    status: 'available',
    tags: ['Beachfront', 'Pool'],
  },
  {
    id: 'prop-002',
    name: 'Mountain View Retreat',
    address: '1840 Pine Ridge Road',
    city: 'Aspen',
    state: 'CO',
    imageUrl: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&auto=format&fit=crop&q=80',
    propertyType: 'vacation-rental',
    price: 2100000,
    totalShares: 4000,
    availableShares: 0,
    targetReturn: 16.2,
    investorCount: 589,
    fundedPercentage: 100,
    status: 'funded',
    tags: ['Ski-In/Ski-Out', 'Hot Tub'],
  },
  {
    id: 'prop-003',
    name: 'Downtown Loft Complex',
    address: '455 Market Street',
    city: 'Austin',
    state: 'TX',
    imageUrl: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1200&auto=format&fit=crop&q=80',
    propertyType: 'multi-family',
    price: 850000,
    totalShares: 1700,
    availableShares: 120,
    targetReturn: 11.8,
    investorCount: 267,
    fundedPercentage: 93,
    status: 'available',
    tags: ['Urban', '8 Units'],
  },
  {
    id: 'prop-004',
    name: 'Suburban Family Home',
    address: '3421 Maple Avenue',
    city: 'Portland',
    state: 'OR',
    imageUrl: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&auto=format&fit=crop&q=80',
    propertyType: 'single-family',
    price: 625000,
    totalShares: 1250,
    availableShares: 875,
    targetReturn: 9.5,
    investorCount: 89,
    fundedPercentage: 30,
    status: 'available',
    tags: ['4 Bed', 'Garage'],
  },
  {
    id: 'prop-005',
    name: 'Lakefront Estate',
    address: '7890 Lake Shore Drive',
    city: 'Lake Tahoe',
    state: 'CA',
    imageUrl: 'https://images.unsplash.com/photo-1600607687644-c7171b42498b?w=1200&auto=format&fit=crop&q=80',
    propertyType: 'luxury',
    price: 3500000,
    totalShares: 7000,
    availableShares: 0,
    targetReturn: 13.5,
    investorCount: 823,
    fundedPercentage: 100,
    status: 'sold_out',
    tags: ['Waterfront', 'Private Dock'],
  },
  {
    id: 'prop-006',
    name: 'Historic Townhouse',
    address: '1842 Beacon Street',
    city: 'Boston',
    state: 'MA',
    imageUrl: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=1200&auto=format&fit=crop&q=80',
    propertyType: 'single-family',
    price: 975000,
    totalShares: 1950,
    availableShares: 390,
    targetReturn: 10.2,
    investorCount: 198,
    fundedPercentage: 80,
    status: 'available',
    tags: ['Historic', 'Renovated'],
  },
  {
    id: 'prop-007',
    name: 'Coastal Apartment Building',
    address: '2100 Pacific Highway',
    city: 'San Diego',
    state: 'CA',
    imageUrl: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1200&auto=format&fit=crop&q=80',
    propertyType: 'multi-family',
    price: 1890000,
    totalShares: 3780,
    availableShares: 1134,
    targetReturn: 12.3,
    investorCount: 412,
    fundedPercentage: 70,
    status: 'available',
    tags: ['Ocean View', '12 Units'],
  },
  {
    id: 'prop-008',
    name: 'Desert Oasis',
    address: '5555 Cactus Road',
    city: 'Scottsdale',
    state: 'AZ',
    imageUrl: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=1200&auto=format&fit=crop&q=80',
    propertyType: 'vacation-rental',
    price: 725000,
    totalShares: 1450,
    availableShares: 725,
    targetReturn: 11.0,
    investorCount: 145,
    fundedPercentage: 50,
    status: 'available',
    tags: ['Golf Course', 'Resort'],
  },
  {
    id: 'prop-009',
    name: 'City Center Duplex',
    address: '789 Broadway',
    city: 'Nashville',
    state: 'TN',
    imageUrl: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=1200&auto=format&fit=crop&q=80',
    propertyType: 'multi-family',
    price: 580000,
    totalShares: 1160,
    availableShares: 232,
    targetReturn: 10.8,
    investorCount: 156,
    fundedPercentage: 80,
    status: 'available',
    tags: ['Music Row', '2 Units'],
  },
  {
    id: 'prop-010',
    name: 'Vineyard Estate',
    address: '4200 Wine Country Lane',
    city: 'Napa Valley',
    state: 'CA',
    imageUrl: 'https://images.unsplash.com/photo-1600585154363-67eb9e2e2099?w=1200&auto=format&fit=crop&q=80',
    propertyType: 'luxury',
    price: 4200000,
    totalShares: 8400,
    availableShares: 1680,
    targetReturn: 15.5,
    investorCount: 612,
    fundedPercentage: 80,
    status: 'available',
    tags: ['Vineyard', 'Wine Cellar'],
  },
  {
    id: 'prop-011',
    name: 'Riverside Cottage',
    address: '321 River Bend',
    city: 'Chattanooga',
    state: 'TN',
    imageUrl: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1200&auto=format&fit=crop&q=80',
    propertyType: 'single-family',
    price: 425000,
    totalShares: 850,
    availableShares: 425,
    targetReturn: 8.9,
    investorCount: 97,
    fundedPercentage: 50,
    status: 'available',
    tags: ['Riverfront', 'Fishing'],
  },
  {
    id: 'prop-012',
    name: 'Urban Studio Complex',
    address: '1500 Tech Boulevard',
    city: 'Seattle',
    state: 'WA',
    imageUrl: 'https://images.unsplash.com/photo-1600573472556-e636c2acda9e?w=1200&auto=format&fit=crop&q=80',
    propertyType: 'multi-family',
    price: 1150000,
    totalShares: 2300,
    availableShares: 0,
    targetReturn: 13.1,
    investorCount: 445,
    fundedPercentage: 100,
    status: 'funded',
    tags: ['Tech Hub', '15 Units'],
  },
];

/**
 * Enhanced Portfolio Holdings with More Diversity
 */
export const DEMO_PORTFOLIO_HOLDINGS = [
  {
    propertyId: 'prop-001',
    propertyName: 'Sunset Beach Villa',
    propertyImage: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=400&auto=format&fit=crop&q=60',
    sharesOwned: 100,
    currentValue: 52340,
    initialInvestment: 50000,
    returnPercentage: 4.68,
    lastDividend: 425.50,
    dividendYield: 10.2,
    monthlyIncome: 425.50,
    acquisitionDate: '2024-03-15',
  },
  {
    propertyId: 'prop-003',
    propertyName: 'Downtown Loft Complex',
    propertyImage: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=400&auto=format&fit=crop&q=60',
    sharesOwned: 75,
    currentValue: 39125,
    initialInvestment: 37500,
    returnPercentage: 4.33,
    lastDividend: 312.75,
    dividendYield: 9.9,
    monthlyIncome: 312.75,
    acquisitionDate: '2024-04-20',
  },
  {
    propertyId: 'prop-006',
    propertyName: 'Historic Townhouse',
    propertyImage: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=400&auto=format&fit=crop&q=60',
    sharesOwned: 50,
    currentValue: 26250,
    initialInvestment: 25000,
    returnPercentage: 5.0,
    lastDividend: 198.25,
    dividendYield: 9.5,
    monthlyIncome: 198.25,
    acquisitionDate: '2024-05-10',
  },
  {
    propertyId: 'prop-007',
    propertyName: 'Coastal Apartment Building',
    propertyImage: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=400&auto=format&fit=crop&q=60',
    sharesOwned: 60,
    currentValue: 31560,
    initialInvestment: 30000,
    returnPercentage: 5.2,
    lastDividend: 265.00,
    dividendYield: 10.6,
    monthlyIncome: 265.00,
    acquisitionDate: '2024-06-01',
  },
];

/**
 * Dashboard Summary for Presentation
 */
export const DEMO_DASHBOARD_SUMMARY = {
  totalPortfolioValue: 149275,
  totalInvestment: 142500,
  totalReturn: 6775,
  totalReturnPercentage: 4.75,
  monthlyIncome: 1201.50,
  annualizedReturn: 10.3,
  activeProperties: 4,
  totalShares: 285,
  lifetimeDividends: 4825.75,
  projectedAnnualIncome: 14418,
};

// ─────────────────────────────────────────────────────────────────────────────
// Crypto Staking Mock Data
// ─────────────────────────────────────────────────────────────────────────────

export const DEMO_CRYPTO_ASSETS: CryptoAsset[] = [
  {
    symbol: 'BTC',
    name: 'Bitcoin',
    balance: '0.2450',
    usdValue: 24500,
    staked: '0.1200',
    stakedUsd: 12000,
    apy: 0.045, // 4.5%
    available: '0.1250',
    availableUsd: 12500,
  },
  {
    symbol: 'ETH',
    name: 'Ethereum',
    balance: '3.5600',
    usdValue: 8900,
    staked: '2.0000',
    stakedUsd: 5000,
    apy: 0.052, // 5.2%
    available: '1.5600',
    availableUsd: 3900,
  },
  {
    symbol: 'USDC',
    name: 'USD Coin',
    balance: '15420.00',
    usdValue: 15420,
    staked: '10000.00',
    stakedUsd: 10000,
    apy: 0.038, // 3.8%
    available: '5420.00',
    availableUsd: 5420,
  },
];

export const DEMO_CRYPTO_NETWORK_FEE = {
  amount: 2.50,
  isEstimate: true,
};

// ─────────────────────────────────────────────────────────────────────────────
// Hive Fund Mock Data
// ─────────────────────────────────────────────────────────────────────────────

export const DEMO_HIVE_FUND_METRICS: FundMetrics = {
  targetApy: 0.12, // 12%
  minInvestment: 25000,
  termYears: 5,
  investorCount: 847,
};

export const DEMO_HIVE_FUND_FUNDRAISING: FundraisingProgress = {
  raised: 2500000,
  target: 10000000,
  percentFunded: 25,
};

export const DEMO_HIVE_FUND_PERFORMANCE: PerformanceDataPoint[] = [
  { month: 'Jan', value: 10000 },
  { month: 'Feb', value: 10450 },
  { month: 'Mar', value: 10820 },
  { month: 'Apr', value: 11150 },
  { month: 'May', value: 11580 },
  { month: 'Jun', value: 12000 },
];

export const DEMO_HIVE_FUND_ASSET_ALLOCATION: AllocationItem[] = [
  { label: 'Multifamily Residential', percentage: 40, color: 'hsl(var(--primary))' },
  { label: 'Commercial Office', percentage: 30, color: '#1944FF' },
  { label: 'Retail', percentage: 20, color: '#242424' },
  { label: 'Industrial', percentage: 10, color: '#888888' },
];

export const DEMO_HIVE_FUND_GEO_DISTRIBUTION: AllocationItem[] = [
  { label: 'West Coast', percentage: 35 },
  { label: 'East Coast', percentage: 30 },
  { label: 'Sun Belt', percentage: 25 },
  { label: 'Midwest', percentage: 10 },
];

export const DEMO_HIVE_FUND_HIGHLIGHTS: FundHighlight[] = [
  { text: '15+ institutional-grade properties' },
  { text: 'Professional property management' },
  { text: 'Quarterly cash distributions' },
  { text: 'Transparent investor reporting' },
];

export const DEMO_HIVE_FUND_DESCRIPTION = `The Hive Fund provides diversified exposure to institutional-grade commercial and residential real estate across major U.S. metro markets. Professionally managed with quarterly distributions and transparent reporting.`;

export const DEMO_HIVE_FUND_DISCLAIMER = `The Hive Fund is a private investment vehicle with a 5-year lock-up period. Minimum investment of $25,000 required. This investment involves risk, including possible loss of principal. Past performance does not guarantee future results. Please review the full prospectus before investing.`;
